import {
	createAdvertisement,
	deleteAdvertisement,
	getAllAdvertisementConfig,
	getAllAdvertisementsData,
	updateAdvertisement,
} from "../api";
import {
	ADVERT_REDUCER_CREATE,
	ADVERT_REDUCER_DELETE,
	ADVERT_REDUCER_GET_ALL,
	ADVERT_REDUCER_GET_ALL_CONFIG,
	ADVERT_REDUCER_UPDATE,
} from "../common/constants";
import ToastPopup from "../common/ToastPopup";

const getAllAdvertConfig = async () => {
	const response = await getAllAdvertisementConfig();
	if (response?.success) {
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const getAllAdverts = async () => {
	const response = await getAllAdvertisementsData();
	if (response?.success) {
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const createAdvert = async (data) => {
	const response = await createAdvertisement(data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const updateAdvert = async (id, data) => {
	const response = await updateAdvertisement(id, data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const deleteAdvert = async (id) => {
	const response = await deleteAdvertisement(id);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

export const AdvertReducer = (state, action) => {
	console.log("advert reducer: ", action);
	switch (action.type) {
		case ADVERT_REDUCER_GET_ALL:
			if (action.loading) {
				getAllAdverts().then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.callback();
				return action.data;
			}

		case ADVERT_REDUCER_CREATE:
			createAdvert(action.data).then((res) => action.callback());
			return state;

		case ADVERT_REDUCER_UPDATE:
			updateAdvert(action.id, action.data).then((res) => action.callback());
			return state;

		case ADVERT_REDUCER_DELETE:
			deleteAdvert(action.id).then((res) => action.callback());
			return state;

		default:
			break;
	}
};

export const AdvertsConfigReducer = (state, action) => {
	switch (action.type) {
		case ADVERT_REDUCER_GET_ALL_CONFIG:
			if (action.loading) {
				getAllAdvertConfig().then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.callback();
				return action.data;
			}

		default:
			break;
	}
};
